(function () {
	'use strict';

	angular.module('app.core')
		.directive('stockRequirement', stockRequirement);

	stockRequirement.$inject = [];
	function stockRequirement() {
		var directive = {
			restrict: 'EA',
			templateUrl: 'core/item-drilldown/stock-requirement.html',
			scope: {
				itemId: '=',
				itemCode: '=',
				siteId: '=',
				itemMasterData: '=',
				incomingLocation: '@',
				haveCurrentShortage: '@',
				mrpTabReady: '=',
				shortageRootCauseType: '@'
			},
			link: linkFunc,
			controller: stockRequirementCtrl,
			controllerAs: 'stockRequirementCtrl',
			bindToController: true
		};

		return directive;

		function linkFunc(scope, el, attr, vm) { }
	}

	stockRequirementCtrl.$inject = ['$scope', '$timeout', '$filter', '$q', 'itemDetailsService', 'formatterService', 'integerFormatService',
		'numberFormatService', 'fullPageChart', 'stockRequirementFiltersService'];
	function stockRequirementCtrl($scope, $timeout, $filter, $q, itemDetailsService, formatterService, integerFormatService,
			numberFormatService, fullPageChart, stockRequirementFiltersService) {
		var vm = this;
		var mrpDataLoadingTimeout;
		vm.loadingStockSection = true;
		vm.mrpList = undefined;

		function getMrpList() {
			vm.loadingStockSection = true;
			var list = stockRequirementFiltersService.getMrpData();
			if (list && list.length) {
				handleMrpData(list, stockRequirementFiltersService.mrpTotal);
			} else {
				var target = vm.itemMasterData.analysisTargetInventoryQty;
				var unrestrictedWithConsignment = vm.itemMasterData.totalOnHandUnrestrictedQuantity +
					vm.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity;

				if (unrestrictedWithConsignment % 1 !== 0) {
					vm.itemMasterData.currentStock = numberFormatService.getWithParameters(
						unrestrictedWithConsignment, decimalPlaces(unrestrictedWithConsignment));
				} else {
					vm.itemMasterData.currentStock = integerFormatService.getWithParameters(unrestrictedWithConsignment, 0);
				}

				if (stockRequirementFiltersService.getMrpDataLoading()) {
					mrpDataLoadingTimeout = $timeout(function () {
						getMrpList();
					}, 15);
				} else { 
					return stockRequirementFiltersService.loadMrpList(vm.itemMasterData.code, vm.siteId, target,
						unrestrictedWithConsignment, vm.itemMasterData.leadTimeInDaysFloat)
						.then(function (data) {
							handleMrpData();
						});
				}
			}
		}

		function handleMrpData() {
			vm.todayDate = $filter('date')(new Date(), 'shortDate');
			setTableVariables();
			vm.loadingStockSection = false;
		}

		function setTableVariables() {
			vm.mrpList = _.cloneDeep(stockRequirementFiltersService.getMrpData());
			if (vm.mrpList && vm.mrpList.length > 0) {
				var total = stockRequirementFiltersService.getMrpTotal();
				vm.hasMrpData = true;
				if (vm.mrpList.length < total) {
					vm.hasMoreMrp = true;
					vm.mrpTotal = total;
				} else {
					vm.hasMoreMrp = false;
				}
			} else {
				vm.hasMoreMrp = false;
			}
		}

		function init(param) {
			if (param && param.useRootCauseDate) {
				getMrpList();
			} else {
				getMrpList();
			}
		}

		var listener;

		this.$onInit = function () {
			if (vm.mrpTabReady){
				init();
			} else {
				listener = $scope.$on('mrpReadyToLoad', function (event, param) {
					init(param);
				});
			}
		};

		$scope.$on('$destroy', function () { 
			if (mrpDataLoadingTimeout) { 
				$timeout.cancel(mrpDataLoadingTimeout);
			}
		});
	}
})();
